export enum Modules {
  Agency = 'agency',
  Business = 'business',
  BusinessSettings = 'businessSettings',
  ProfileSettings = 'profileSettings',
  PipelineSettings = 'pipelineSettings',
  AgentReporting = 'agentReporting',
  Reputation = 'reputation',
  AdReporting = 'adReporting',
  Blogs = 'blogs',
  Eliza = 'eliza',
  Copilot = 'copilot',
  Launchpad = 'launchpad',
  ContactDetail = 'contactDetail',
  Task = 'task',
  ChatWidgetBuilder = 'chatWidgetBuilder',
  Yext = 'yext',
  SmartList = 'smartList',
  CustomField = 'customField',
  RestoreContacts = 'restoreContacts',
  BulkActions = 'bulkActions',
  Payments = 'payments',
  Common = 'common',
  TriggerLinkAnalyze = 'triggerLinkAnalyze',
  ManualActions = "manualActions",
  Snapshots = "snapshots",
  Wordpress = "wordpress",
  Conversations = "conversations",
  Prospecting = "prospecting",
  Reselling = "reselling",
  Seo = "seo"
}
